<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 lg4>
        <v-card class="pi-card">
          <v-subheader>Projekt</v-subheader>
          <v-img src="/logo.png" class="pi-card-media" height="80px" :contain="true"></v-img>
          <v-card-text>
            <div class="subheading">{{ Auth.projectData.description}}</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 lg4>
        <v-card>
          <v-subheader>Wydarzenia w tym tygodniu</v-subheader>
          <v-subheader v-if="dates.length < 1">Brak wydarzeń</v-subheader>
          <v-card-text v-if="dates.length > 0">
            <template v-for="event in dates">
              <pi-event
                :key="event.id"
                :event="event"
                hideEdit="true"
              ></pi-event>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 lg4>
        <v-card>
          <v-list subheader>
            <v-subheader>Statystyki</v-subheader>
            <v-list-tile v-for="statistic in statistics" :key="statistic.id" avatar>
              <v-list-tile-avatar>
                <v-icon class="accent white--text">{{ statistic.icon }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ statistic.count }} {{ statistic.count == 1 ? statistic.lang[0] : (5 >= statistic.count || statistic.count == 0 ? statistic.lang[1] : statistic.lang[2]) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <pi-changes id="0"></pi-changes>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    files: 0,
    users: 0,
    groups: 0,
    fileTreeChanges: 0,
    statistics: [],
    dates: []
  }),
  methods: {
    async getData() {
      const [responseStat, responseDate] = await Promise.all([
        this.Api.send("get", "/statistics"),
        this.Api.send("get", `/dates?from=${this.from}&to=${this.to}`)
      ]);
      if (responseDate.status) {
        this.dates = responseDate.dates.map(v => {
          return {
            id: v.id,
            name: v.name,
            description: v.description,
            date: new Date(v.date)
              .toLocaleDateString("en-GB")
              .split("/")
              .reverse()
              .join("-")
          };
        });
      }
      if (!responseStat.status) return;
      this.createStatistics(responseStat);
    },
    async createStatistics({ files, users, groups, fileTreeChanges }) {
      let i = 0;
      const createObj = (count, icon, lang) => {
        return { id: i++, count, icon, lang };
      };
      this.statistics = [
        createObj(files, "insert_drive_file", ["plik", "pliki", "plików"]),
        createObj(users, "account_circle", [
          "użytkownik",
          "użytkownicy",
          "użytkowników"
        ]),
        createObj(groups, "group", ["grupa", "grupy", "grup"]),
        createObj(fileTreeChanges, "history", ["zmiana", "zmiany", "zmian"])
      ];
    }
  },
  computed: {
    eventsMap() {
      const map = {};
      this.dates.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    },
    from() {
      return new Date()
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-");
    },
    to() {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      return d
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-");
    }
  },
  async mounted() {
    await this.createStatistics({
      files: 0,
      users: 0,
      groups: 0,
      fileTreeChanges: 0
    });
    await this.getData();
  }
};
</script>